import { date } from 'configuration/dayjs'
import {
    CATEGORY,
    CATEGORY_NAME,
    CATEGORY_ASIN,
    COUNTRIES,
    DATES,
    METRIC_FILTERS,
} from 'const/filters'
import { isNonEmptyArray } from 'helpers/typeGuard'
import { formatDateFromFilter } from 'helpers/utils'
import {
    FiltersState,
    CategoryPerformanceFactsParams,
    FilterOption,
    MetricFilter,
} from 'types'

import { formatMetricFiltersForParams } from './metrics'

const stringifyFilterOptions = (
    options: (FilterOption | MetricFilter)[],
    customFormatter: (value: string | number) => string
): string =>
    options
        .map((item) =>
            customFormatter
                ? item.value && customFormatter(item.value)
                : item.value
        )
        .join()

export const formatFilters = (
    filters: FiltersState,
    _hasHourlyData = false,
    fiscalYearStartMonth?: number
): CategoryPerformanceFactsParams => {
    let params: CategoryPerformanceFactsParams = {}

    const dates = filters[DATES]
    const { start, end } = formatDateFromFilter(
        dates,
        date(),
        filters.rangeLag,
        fiscalYearStartMonth
    )
    params.report_start_date_min = start
    params.report_start_date_max = end

    const countries = filters[COUNTRIES]
    if (isNonEmptyArray(countries)) {
        params.country_code__in = stringifyFilterOptions(
            countries,
            (value: string | number) => value.toString().toLowerCase()
        )
    }

    const metricFilters = filters[METRIC_FILTERS]
    if (isNonEmptyArray(metricFilters)) {
        params = { ...params, ...formatMetricFiltersForParams(metricFilters) }
    }

    const categoryFilters = filters[CATEGORY]

    if (isNonEmptyArray(categoryFilters)) {
        params.category_node_id__in = stringifyFilterOptions(
            categoryFilters,
            (value: string | number) => (value as string).split('/')[1]
        )
    }

    const categoryNameFilter = filters[CATEGORY_NAME]
    if (
        categoryNameFilter &&
        typeof categoryNameFilter === 'string' &&
        categoryNameFilter.trim() !== ''
    ) {
        params.name = categoryNameFilter
    }

    const categoryAsinFilter = filters[CATEGORY_ASIN]
    if (
        categoryAsinFilter &&
        typeof categoryAsinFilter === 'string' &&
        categoryAsinFilter.trim() !== ''
    ) {
        params.asin = categoryAsinFilter
    }

    return params
}
